(()=>{
  'use strict';
  const root=document.querySelector('.t21-home');
  if(!root||root.dataset.t21MotionInitialized)return;
  root.dataset.t21MotionInitialized='true';
  const media=matchMedia('(prefers-reduced-motion: reduce)');
  const hero=root.querySelector('.hero-image');
  const pending=new Set();
  let observer=null,mutations=null,frame=0,active=false;
  const targets=[
    '.collections-section>.section-heading','.collection-card','.collection-shortcuts',
    '.finder-section>.section-heading','.finder-panel','.engine-quicklinks','.finder-note',
    '.catalog-section>.section-heading','.catalog-toolbar','.product-card','.price-note',
    '.engineering-art','.engineering-copy','.world-section>.section-heading','.world-card',
    '.faq-section>div','.closing'
  ].join(',');
  function reveal(element){
    element.dataset.t21Reveal='visible';
    pending.delete(element);
    observer?.unobserve(element);
  }
  function clean(){
    active=false;
    observer?.disconnect();
    mutations?.disconnect();
    observer=null;
    mutations=null;
    cancelAnimationFrame(frame);
    frame=0;
    root.classList.remove('t21-motion-ready');
    root.style.removeProperty('--t21-hero-pan');
    root.querySelectorAll('[data-t21-reveal]').forEach(element=>{
      element.removeAttribute('data-t21-reveal');
      element.style.removeProperty('--t21-reveal-delay');
    });
    pending.clear();
  }
  function prepare(element){
    if(!active||element.hasAttribute('data-t21-reveal'))return;
    // Never hide already-visible content, including controls or restored scroll positions.
    if(element.getBoundingClientRect().top<innerHeight-24){
      element.dataset.t21Reveal='visible';
      return;
    }
    const columns=innerWidth<600?2:3;
    const index=element.matches('.collection-card,.product-card,.world-card')?Array.from(element.parentElement.children).indexOf(element):0;
    element.style.setProperty('--t21-reveal-delay',`${index%columns*80}ms`);
    element.dataset.t21Reveal='pending';
    pending.add(element);
    observer.observe(element);
  }
  function pan(){
    frame=0;
    if(!active||!hero||document.hidden)return;
    const rect=hero.getBoundingClientRect();
    if(rect.bottom<0||rect.top>innerHeight)return;
    const limit=innerWidth<600?7:16;
    const offset=Math.max(-limit,Math.min(limit,(innerHeight*.45-rect.top-rect.height*.5)*.035));
    root.style.setProperty('--t21-hero-pan',offset.toFixed(2)+'px');
  }
  function schedulePan(){
    if(active&&!frame)frame=requestAnimationFrame(pan);
  }
  function start(){
    clean();
    root.querySelectorAll('.reveal.waiting').forEach(element=>element.classList.remove('waiting'));
    if(media.matches||!('IntersectionObserver'in window))return;
    try{
      observer=new IntersectionObserver(entries=>{
        for(const entry of entries)if(entry.isIntersecting)reveal(entry.target);
      },{threshold:.06,rootMargin:'0px 0px -20px 0px'});
      active=true;
      root.classList.add('t21-motion-ready');
      root.querySelectorAll(targets).forEach(prepare);
      const grid=root.querySelector('#product-grid');
      if(grid&&'MutationObserver'in window){
        mutations=new MutationObserver(()=>{
          for(const element of pending)if(!element.isConnected){observer.unobserve(element);pending.delete(element);}
          grid.querySelectorAll('.product-card').forEach(prepare);
        });
        mutations.observe(grid,{childList:true});
      }
      schedulePan();
    }catch{clean();}
  }
  root.addEventListener('focusin',event=>{
    // Keyboard access must not wait for a visual entrance animation.
    const element=event.target.closest('[data-t21-reveal="pending"]');
    if(element){element.style.setProperty('--t21-reveal-delay','0ms');element.style.setProperty('transition-duration','0s');reveal(element);}
  });
  window.addEventListener('scroll',schedulePan,{passive:true});
  window.addEventListener('resize',schedulePan,{passive:true});
  window.addEventListener('pageshow',event=>{if(event.persisted)start();});
  document.addEventListener('visibilitychange',schedulePan);
  if(media.addEventListener)media.addEventListener('change',start);
  else media.addListener(start);
  start();
})();
